import styled from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
import { List } from '../styled';
export const CollapsibleContent = styled.div `
  display: ${(props) => (props.$open ? 'block' : 'none')};
  margin-left: ${theme.spacing['2xl']};
  overflow: hidden;

  ${List} {
    padding: 0;
    min-width: auto;
  }
`;
export const IconContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;

  [data-icon='falcon'] {
    color: ${theme.swatches.gray[500]};
    width: ${pxToRem(12)};
  }
`;
